/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomUser } from './CustomUser';
import {
    CustomUserFromJSON,
    CustomUserFromJSONTyped,
    CustomUserToJSON,
    CustomUserToJSONTyped,
} from './CustomUser';

/**
 * 
 * @export
 * @interface PaginatedCustomUserList
 */
export interface PaginatedCustomUserList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCustomUserList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCustomUserList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCustomUserList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<CustomUser>}
     * @memberof PaginatedCustomUserList
     */
    results: Array<CustomUser>;
}

/**
 * Check if a given object implements the PaginatedCustomUserList interface.
 */
export function instanceOfPaginatedCustomUserList(value: object): value is PaginatedCustomUserList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedCustomUserListFromJSON(json: any): PaginatedCustomUserList {
    return PaginatedCustomUserListFromJSONTyped(json, false);
}

export function PaginatedCustomUserListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCustomUserList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(CustomUserFromJSON)),
    };
}

  export function PaginatedCustomUserListToJSON(json: any): PaginatedCustomUserList {
      return PaginatedCustomUserListToJSONTyped(json, false);
  }

  export function PaginatedCustomUserListToJSONTyped(value?: PaginatedCustomUserList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(CustomUserToJSON)),
    };
}

